import * as yup from 'yup';
import { ERegExpTypes } from 'constants/RegExpTypes';

export const schema = yup.object({
  authCode: yup
    .string()
    .required('The authentication code is invalid or expired. Please try again.')
    .matches(
      new RegExp(ERegExpTypes['4digits']),
      'The authentication code is invalid or expired. Please try again.',
    ),
});
